import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: '頁面大小',
	PageOrientation: '頁面方向',
	Format: '格式',
	DPI: '像素',
	Generate: '導出',
	LanguageName: '繁体字',
	LanguageCode: 'zhHant'
};

export default translation;
